/* eslint-disable @typescript-eslint/prefer-optional-chain */
export type DeviceType = 'ios' | 'android' | 'other';

export function detectDeviceSystem(): DeviceType {
  if (typeof window !== 'undefined' && window.navigator) {
    const userAgent = window.navigator.userAgent.toLowerCase();

    if (/ipad|iphone|ipod/.test(userAgent)) {
      return 'ios';
    }

    if (/android/i.test(userAgent)) {
      return 'android';
    }
  }
  return 'other';
}
